// Desktop mega menu: swiper + scroll + hover dropdown helpers. Moved out of snippets/header-menu-desktop.liquid
// (was inline on every page: re-downloaded inside the HTML each time; as a file it is cached).
// ======================= swiper + scroll + hover =====================
// Runs as soon as this deferred file executes (the HTML is already parsed then), instead of waiting for
// DOMContentLoaded, which on a reload only fires after every other deferred/app script. A hover in that
// gap used to show the mega menu with its default centred position, cut off on the left (only part of
// the menu visible) until the mouse left and came back.
function jitInitHeaderMenuDesktop() {
  if (window.__SBS_INIT__) return; // prevent double init
  window.__SBS_INIT__ = true;

  function initDesktopFeatures() {
    if (window.innerWidth <= 760) return; // run only above 900px

    // ================= Swiper init =================
    document.querySelectorAll('.sbs-wrapper.sbs-wrapper-desktop').forEach(function(root){
      const dialSwiperEl = root.querySelector('.sbs-dial-swiper-desktop');
      if (dialSwiperEl && !dialSwiperEl.classList.contains('swiper-initialized')) {
        const dialSwiper = new Swiper(dialSwiperEl, {
          slidesPerView: 0.2,
          freeMode: {
            enabled: true,
            momentum: false,
          },
          breakpoints: {
            640: { slidesPerView: 0.2 },
            960: { slidesPerView: 0.3 },
          }
        });

        const dialNextBtn = root.querySelector('.sbs-dial-next-desktop');
        const dialPrevBtn = root.querySelector('.sbs-dial-prev-desktop');
        const EDGE_TOLERANCE = 1;

        function getDialMaxNegativeTranslate() {
          let screen_width = window.innerWidth;
          if (screen_width <= 990) {
            return -600;
          } else if (screen_width <= 1100) {
            return -480;
          } else if (screen_width <= 1300) {
            return -420;
          } else if (screen_width <= 1500) {
            return -400;
          } else {
            return -320;
          }
        }
        function updateDialNavDisabledState() {
          const currentTranslate = dialSwiper.getTranslate();
          const minTranslate = 0;
          const maxNegativeTranslate = getDialMaxNegativeTranslate();

          if (dialPrevBtn) {
            dialPrevBtn.classList.toggle(
              'swiper-button-disabled',
              currentTranslate >= (minTranslate - EDGE_TOLERANCE)
            );
          }

          if (dialNextBtn) {
            dialNextBtn.classList.toggle(
              'swiper-button-disabled',
              currentTranslate <= (maxNegativeTranslate + EDGE_TOLERANCE)
            );
          }
        }

        function moveDialSlider(direction) {
          if (!dialSwiper || dialSwiper.destroyed) return;

          const moveBy = dialSwiper.el.offsetWidth * 0.1; // move by 10%
          let newTranslate = direction === 'next'
            ? dialSwiper.getTranslate() - moveBy
            : dialSwiper.getTranslate() + moveBy;

          // keep translate inside valid Swiper limits
          const max = getDialMaxNegativeTranslate();
          const min = dialSwiper.minTranslate();
          if (newTranslate > min) newTranslate = min;
          if (newTranslate < max) newTranslate = max;

          dialSwiper.translateTo(newTranslate, 350);
        }

        if (dialNextBtn && !dialNextBtn.dataset.customDialNavBound) {
          dialNextBtn.dataset.customDialNavBound = 'true';
          dialNextBtn.addEventListener('click', function(e){
            e.preventDefault();
            if (dialNextBtn.classList.contains('swiper-button-disabled')) return;
            moveDialSlider('next');
          });
        }

        if (dialPrevBtn && !dialPrevBtn.dataset.customDialNavBound) {
          dialPrevBtn.dataset.customDialNavBound = 'true';
          dialPrevBtn.addEventListener('click', function(e){
            e.preventDefault();
            if (dialPrevBtn.classList.contains('swiper-button-disabled')) return;
            moveDialSlider('prev');
          });
        }

        dialSwiper.on('setTranslate', function ( translate) {
          const maxNegativeTranslate = getDialMaxNegativeTranslate();

          // clamp both ends during drag / scrollbar / mouse interactions
          if (translate.translate < maxNegativeTranslate) dialSwiper.setTranslate(maxNegativeTranslate);
          if (translate.translate > 0) dialSwiper.setTranslate(0);
          updateDialNavDisabledState();
        });

        dialSwiper.on('transitionEnd', updateDialNavDisabledState);
        updateDialNavDisabledState();

        if (!dialSwiperEl.dataset.customDialNavResizeBound) {
          dialSwiperEl.dataset.customDialNavResizeBound = 'true';
          window.addEventListener('resize', updateDialNavDisabledState);
        }
      }

      const strapSwiperEl = root.querySelector('.sbs-strap-swiper-desktop');
      if (strapSwiperEl && !strapSwiperEl.classList.contains('swiper-initialized')) {
        new Swiper(strapSwiperEl, {
        slidesPerView: 2.5,
        spaceBetween: 11.92,
        navigation: {
          nextEl: root.querySelector('.sbs-strap-next-desktop'),
          prevEl: root.querySelector('.sbs-strap-prev-desktop'),
        },
        breakpoints: {
          640: { slidesPerView: 2.6 },
          1024:{ slidesPerView: 2.8 }
        }
        });
      }
    });

    // =============== desktop scroll bar code =================
    const containers = document.querySelectorAll(
      ".sbs-menu-overFlow-design, .sbs-menu-overFlow-design-desktop"
    );
    containers.forEach(container => {
      const wrapper = container.closest(".menu-item-mega-menu-desktop") || container.parentElement;
      const track = wrapper?.querySelector(".custom-scrollbar-desktop");
      const thumb = track?.querySelector(".custom-scrollbar-thumb-desktop");
      if (!track || !thumb) return;
      let isDragging = false;
      let dragOffsetY = 0;

      function updateThumb() {
        const isVertical = container.scrollHeight > container.clientHeight;
        const scrollSize = isVertical 
          ? container.scrollHeight - container.clientHeight 
          : container.scrollWidth - container.clientWidth;
        const scrollPos = isVertical ? container.scrollTop : container.scrollLeft;

        const trackSize = isVertical ? track.clientHeight : track.clientWidth;
        const thumbSize = isVertical ? thumb.offsetHeight : thumb.offsetWidth;

        const maxPos = Math.max(0, trackSize - thumbSize);
        const ratio = scrollPos / Math.max(1, scrollSize);

        thumb.style[isVertical ? "top" : "left"] = Math.min(maxPos, ratio * maxPos) + "px";
        thumb.style[isVertical ? "left" : "top"] = "0";
      }

      function syncScrollFromThumb(clientY) {
        const trackRect = track.getBoundingClientRect();
        const thumbHeight = thumb.offsetHeight;
        const maxThumbTop = Math.max(0, track.clientHeight - thumbHeight);
        let nextTop = clientY - trackRect.top - dragOffsetY;
        nextTop = Math.max(0, Math.min(nextTop, maxThumbTop));

        thumb.style.top = `${nextTop}px`;

        const maxScrollTop = Math.max(0, container.scrollHeight - container.clientHeight);
        const ratio = maxThumbTop > 0 ? nextTop / maxThumbTop : 0;
        container.scrollTop = ratio * maxScrollTop;
      }

      function onPointerMove(e) {
        if (!isDragging) return;
        e.preventDefault();
        syncScrollFromThumb(e.clientY);
      }

      function onPointerUp() {
        if (!isDragging) return;
        isDragging = false;
        thumb.classList.remove('is-dragging');
        window.removeEventListener('pointermove', onPointerMove);
        window.removeEventListener('pointerup', onPointerUp);
      }

      if (!thumb.dataset.dragBound) {
        thumb.dataset.dragBound = "true";
        thumb.addEventListener('pointerdown', (e) => {
          e.preventDefault();
          isDragging = true;
          const thumbRect = thumb.getBoundingClientRect();
          dragOffsetY = e.clientY - thumbRect.top;
          thumb.classList.add('is-dragging');
          window.addEventListener('pointermove', onPointerMove);
          window.addEventListener('pointerup', onPointerUp);
        });
      }

      if (!track.dataset.trackClickBound) {
        track.dataset.trackClickBound = "true";
        track.addEventListener('click', (e) => {
          if (e.target === thumb) return;
          dragOffsetY = thumb.offsetHeight / 2;
          syncScrollFromThumb(e.clientY);
        });
      }

      container.addEventListener("scroll", updateThumb);
      window.addEventListener("resize", updateThumb);
      requestAnimationFrame(updateThumb);

      if (window.ResizeObserver) {
        const ro = new ResizeObserver(updateThumb);
        ro.observe(container);
        ro.observe(track);
      }

      // Allow wheel scrolling even when pointer is over the custom track/thumb.
      function handleWheelOnCustomScrollbar(event) {
        const delta = Math.abs(event.deltaY) >= Math.abs(event.deltaX) ? event.deltaY : event.deltaX;
        if (!delta) return;
        container.scrollTop += delta;
        event.preventDefault();
      }
      track.addEventListener("wheel", handleWheelOnCustomScrollbar, { passive: false });
      thumb.addEventListener("wheel", handleWheelOnCustomScrollbar, { passive: false });

      // Allow dragging the custom thumb to scroll the menu.
      let dragStartY = 0;
      let dragStartTop = 0;
      let draggingThumb = false;

      function stopThumbDrag() {
        if (!draggingThumb) return;
        draggingThumb = false;
        document.body.style.userSelect = "";
      }

      function onThumbDrag(event) {
        if (!draggingThumb) return;
        const trackSize = track.clientHeight;
        const thumbSize = thumb.offsetHeight;
        const maxThumbTop = Math.max(0, trackSize - thumbSize);
        const proposedTop = dragStartTop + (event.clientY - dragStartY);
        const nextTop = Math.max(0, Math.min(maxThumbTop, proposedTop));
        const ratio = maxThumbTop > 0 ? nextTop / maxThumbTop : 0;
        container.scrollTop = ratio * Math.max(0, container.scrollHeight - container.clientHeight);
      }

      thumb.addEventListener("mousedown", function (event) {
        event.preventDefault();
        dragStartY = event.clientY;
        dragStartTop = parseFloat(thumb.style.top) || 0;
        draggingThumb = true;
        document.body.style.userSelect = "none";
      });

      document.addEventListener("mousemove", onThumbDrag);
      document.addEventListener("mouseup", stopThumbDrag);
      document.addEventListener("mouseleave", stopThumbDrag);
    });

// Dropdown positioning ("hover dropdown adjust") lives inline in snippets/header-menu-desktop.liquid,
    // right after the menu HTML, so it works from the first hover while the page is still loading.
  }
  initDesktopFeatures();
  let wasDesktop = window.innerWidth > 900;
  window.addEventListener('resize', () => {
    const isDesktop = window.innerWidth > 900;
    if (isDesktop && !wasDesktop) {
      initDesktopFeatures();
    }
    wasDesktop = isDesktop;
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', jitInitHeaderMenuDesktop);
} else {
  jitInitHeaderMenuDesktop();
}
